import { Button, formUtils, Modal } from '@insurancemenu/imenu-components-lib';
import React from 'react';
import { shouldEntityBeRendered } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { FormObjectFromJSON } from '@insurancemenu/imenu-components-lib/dist/types';
import { observer } from 'mobx-react-lite';
import clsx from 'clsx';
import { toJS } from 'mobx';
import FormsSpinner from 'components/common/general/FormSpinner';
import Section from 'components/common/general/Section';
import { createStyles } from './styles';

interface Props {
  show: boolean;
  closable?: boolean;
  onClose: () => void;
  onAction: (e: React.FormEvent) => void;
  dynamicForm: null | formUtils.DynamicFormController;
  form: FormObjectFromJSON;
  loading: boolean;
  footerCancelButton?: JSX.Element;
  footerSubmitButton?: JSX.Element;
  isFormNotEditable?: boolean;
  modalMaxWidth?: string;
  actionButtonText?: string;
  className?: string;
  formStyles?: string;
}

const DynamicFormModal = observer(
  ({
    show,
    closable = true,
    onClose,
    onAction,
    loading,
    dynamicForm,
    form,
    footerCancelButton,
    footerSubmitButton,
    actionButtonText = '',
    isFormNotEditable = false,
    modalMaxWidth = '',
    className,
    formStyles,
  }: Props): JSX.Element => {
    const classes = createStyles({ modalMaxWidth });

    return (
      <Modal show={show} onClose={onClose} closable={closable} className={clsx(classes.modal, className)}>
        {loading ? (
          <FormsSpinner display={loading} />
        ) : (
          <>
            <h3 className={classes.title}>{form.formTitle}</h3>
            <form
              onSubmit={onAction}
              className={clsx(classes.form, formStyles, isFormNotEditable && classes.disableForm)}
            >
              <div>
                {dynamicForm &&
                  form.sections
                    .map((section) => toJS(section))
                    .slice()
                    .map((section) => {
                      // doesn't show section without visible components inside (they can be invisible because of showWhen parameter)
                      if (dynamicForm && !shouldEntityBeRendered(section.showWhen, dynamicForm.fields)) {
                        return <React.Fragment key={section.title} />;
                      }
                      return (
                        <Section title={section.title} key={section.title} contentStyle={classes.section}>
                          {section.layout.map((entity) => {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            return formUtils.renderEntity(entity, dynamicForm, []);
                          })}
                        </Section>
                      );
                    })}
              </div>
            </form>
            <footer className={classes.modalFooter}>
              {footerCancelButton || (
                <Button type="outlined" onClick={onClose} size="large">
                  {isFormNotEditable ? 'Exit' : 'Cancel'}
                </Button>
              )}
              {!isFormNotEditable &&
                (footerSubmitButton || (
                  <Button
                    disabled={!dynamicForm?.isFormValid()}
                    color="primary"
                    onClick={onAction}
                    size="large"
                    htmlType="submit"
                  >
                    {actionButtonText || 'Save'}
                  </Button>
                ))}
            </footer>
          </>
        )}
      </Modal>
    );
  },
);

export default DynamicFormModal;
